import PagingSelection from './PagingSelection'

export default PagingSelection
